import { Table, TableBody, TableCell, TableHead, TableRow, useTheme } from '@mui/material';
import { Link } from '@tanstack/react-router';

import { I18N_DE } from '@/i18n/de';
import type { OrganizationUser } from '@/modules/api/backend';

interface OrganizationUserTableProps {
  organizationUserData: OrganizationUser[];
}

export function OrganizationUserTable({ organizationUserData }: OrganizationUserTableProps) {
  const theme = useTheme();

  return (
    <Table aria-label="User*innen">
      <TableHead>
        <TableRow>
          <TableCell>E-Mail</TableCell>
          <TableCell>Berechtigung</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {organizationUserData.length === 0 ? (
          <TableRow>
            <TableCell align="center" colSpan={3}>
              Keine User gefunden.
            </TableCell>
          </TableRow>
        ) : (
          organizationUserData.map((organizationUser) => (
            <TableRow
              key={organizationUser.userId}
              component={Link}
              to={`organizationUsers/${organizationUser.userId}`}
              sx={{
                textDecoration: 'none',
                cursor: 'pointer',
                '&:hover': { backgroundColor: theme.palette.action.hover },
                '& .MuiTableCell-root': {
                  textDecoration: 'none',
                },
              }}
            >
              <TableCell>{organizationUser.user?.email ?? '—'}</TableCell>
              <TableCell>{I18N_DE.OrganizationUserRole[organizationUser.role]}</TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
